import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Notification, { showToast } from "../../../../components/common/notification/Notification";
import useSubscriptionPlans from "./useSubscriptionPlans";
import useUserDetails from "./useUserDetails";
import PaymentPlans from "./PaymentPlans";
import UserProfile from "../UserProfile";
import BreadCrumb from "../../../components/breadcrumb/BreadCrumb";
import PlanCard from "./PlanCard";
import { Accordion } from "react-bootstrap";

const UserPayment = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.user?.id;

  const userDetails = useUserDetails(userId);

  const {
    plans,
    selectedPlan,
    setSelectedPlan,
    expandedPlan,
    setExpandedPlan,
    loading: plansLoading
  } = useSubscriptionPlans();

  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const razorpay_key = process.env.REACT_APP_RAZORPAY_KEY;

  const [loading, setLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);

  const fetchOrderId = async () => {
    setApiLoading(true);
    try {
      const payload = {
        user_id: userId.toString(),
        rating: 0,
        subscription_plan_id: setSelectedPlan,
        is_registration: true,
      };

      const response = await axios.post(`${baseUrl}/payments/getRazorPaymentOrderId`, payload);

      if (response.data.statusType === "SUCCESS") {
        localStorage.setItem("paymentAmount", response.data.amount);
        return { orderId: response.data.orderId, amount: response.data.amount.toString() };
      }

      showToast("Order ID fetch failed", { type: "error" });
      return null;
    } catch (err) {
      showToast("Network error. Try again.", { type: "error" });
      return null;
    } finally {
      setApiLoading(false);
    }
  };

  const handlePayment = async () => {
    setLoading(true);
    try {
      const order = await fetchOrderId();
      if (!order) return;

      const options = {
        key: razorpay_key,
        amount: order.amount,
        currency: "INR",
        name: "Ushma Infotech Private Limited",
        description: "Payment for subscription",
        order_id: order.orderId,

        handler: async (response) => {
          try {
            const verifyPayload = {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            };

            const verifyRes = await axios.put(
              `${baseUrl}/payments/saveAndVerifyPayment`,
              verifyPayload
            );

            if (verifyRes.data.statusType === "SUCCESS") {
              navigate("/user/upload-payment-screen-shot", {
                state: {
                  message: "Payment Successful",
                  paymentDetails: verifyPayload,
                  userId: userDetails.partner_id,
                  razorpayPaymentId: response.razorpay_payment_id,
                },
              });
            } else {
              showToast(verifyRes.data.text || "Payment verification failed", { type: "error" });
            }
          } catch {
            showToast("Payment verification failed", { type: "error" });
          }
        },

        prefill: {
          name: `${userDetails.first_name} ${userDetails.last_name}`.trim(),
          email: userDetails.email_address,
          contact: userDetails.mobile_number,
        },

        theme: { color: "#0d6efd" },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", () => {
        showToast("Payment failed. Please try again.", { type: "error" });
      });
      rzp.open();
    } catch {
      showToast("Payment failed", { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleProceed = () => {
    showToast("Proceeding to Payment not yet implemented ", { type: "info" });
  }
  const breadcrumbItems = [
    { label: "", link: "/", icon: "fa-solid fa-house" },
    { label: "Profile", link: "/user/profile" },
    { label: "User Payment Details", link: "", active: true },
  ];

  return (
    <Container fluid>
      <Notification />
      <BreadCrumb items={breadcrumbItems} />

      <Row className="justify-content-center">
        <Col md={4} lg={3}>
          <UserProfile />
        </Col>

        <Col md={8} lg={8}>
          <div className="card shadow border-0 rounded-3 p-4 my-2 profile-card">
            <Accordion activeKey={expandedPlan?.toString()}>
              {plans.map((plan) => (
                <PlanCard
                  key={plan.id}
                  plan={plan}
                  selectedPlan={selectedPlan}
                  expandedPlan={expandedPlan}
                  setSelectedPlan={setSelectedPlan}
                  setExpandedPlan={setExpandedPlan}
                  userDetails={userDetails}
                  onProceed={handleProceed}
                />
              ))}
            </Accordion>
          </div>

        </Col>
      </Row>
    </Container>
  );
};

export default UserPayment;
